if (!customElements.get('collapsible-space-helper')) {
  class CollapsibleSpaceHelper extends HTMLElement {
    constructor() {
      super();
      this.detailsContainer = this.querySelectorAll('details:not(details details)');
      this.spacer = this.querySelector('.fake-spacer');
      this.currentOpenDetails = null;

      this.toggleHandler = this.handleToggle.bind(this);

      this.init();
    }

    init() {
      this.handleCartUpdate();
      window.addEventListener('cart:updated', this.handleCartUpdate);
    }

    attachListeners() {
      this.detailsContainer.forEach((details) => {
        details.removeEventListener('toggle', this.toggleHandler);
        details.addEventListener('toggle', this.toggleHandler);
      });
    }

    observeInnerDetails() {
      this.detailsContainer.forEach((details) => {
        const content = details.querySelector('summary + *');
        if (content) {
          const observer = new MutationObserver(() => {
            this.updateSpacerHeight();
          });
          observer.observe(content, { childList: true, subtree: true, attributes: true });
        }
      });
    }

    handleCartUpdate() {
      this.detailsContainer = this.querySelectorAll('details:not(details details)');
      this.attachListeners();
      this.observeInnerDetails();
    }

    handleToggle(event) {
      const currentDetails = event.currentTarget;

      if (currentDetails.hasAttribute('open')) {
        this.closeOtherDetails(currentDetails);

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const content = currentDetails.querySelector('summary + *');

            if (content) {
              this.spacer.style.height = `${content.offsetHeight}px`;
            }
          });
        });

        this.currentOpenDetails = currentDetails;
      } else {
        if (this.currentOpenDetails === currentDetails) {
          this.spacer.style.height = '0px';
          this.currentOpenDetails = null;
        }
      }
    }

    updateSpacerHeight() {
      if (this.currentOpenDetails) {
        const content = this.currentOpenDetails.querySelector('summary + *');
        if (content) {
          this.spacer.style.height = `${content.offsetHeight}px`;
        }
      }
    }

    closeOtherDetails(currentDetails) {
      this.detailsContainer.forEach((details) => {
        if (details !== currentDetails && details.hasAttribute('open')) {
          details.removeAttribute('open');
        }
      });
    }
  }

  customElements.define('collapsible-space-helper', CollapsibleSpaceHelper);
}
